import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useUserStore } from "../../../store/userStore.js";


import UserProfileLayout from "../../../components/layout/userprofilelayout/userprofilelayout";

import ProfileTab from "../../../components/tab/profiletab";
import Spacer from "../../../components/spacer/spacer";

import matchPreferenceItems from "../../../utils/arrayitems/matchpreferenceitems";

import BasicInfo from "./basicinfo";
import BodyPreference from "./bodypreference";
import EducationCareer from "./educationcareer";
import Description from "./description";

import "./styles.css";

const EditMatchPreference = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { getUser } = useUserStore();

  const queryParams = new URLSearchParams(location.search);
  const username = location.pathname.split("/")[2];

  const [activeTab, setActiveTab] = useState(
    queryParams.get("tab") ?? "basicInfo"
  );

  useEffect(() => {
    getprofileData();
  }, [username, queryParams]);

  const getprofileData = () => {
    const payload = { username };
    getUser(payload);
  };

  const handleTab = (name) => {
    setActiveTab(name);
    navigate(`/userprofileoverview/${username}/editUserMatchPref?tab=${name}`);
  };

  return (
    <UserProfileLayout>
      <div className="edit-profile-container">
        <ProfileTab
          tabItems={matchPreferenceItems}
          handleTab={handleTab}
          activeTab={activeTab}
        />

        <Spacer height="32px" />
        <div className="edit-profile-content-container">
          {activeTab === "bodyPreference" ? (
            <BodyPreference handleTab={handleTab} />
          ) : activeTab === "educationCareer" ? (
            <EducationCareer handleTab={handleTab} />
          ) : activeTab === "idealMatch" ? (
            <Description handleTab={handleTab} />
          ) : (
            <BasicInfo handleTab={handleTab} />
          )}
        </div>
      </div>
    </UserProfileLayout>
  );
};

export default EditMatchPreference;








